export var INFO_CARD_IMAGE_HEIGHT_EXTRA_SMALL = {
  xs: 120,
  md: 128,
  lg: 132,
  xl: 140
};
export var INFO_CARD_IMAGE_HEIGHT_TINY = {
  xs: 132,
  lg: 120,
  xl: 146
};
export var INFO_CARD_IMAGE_HEIGHT_SMALL = {
  xs: 132,
  lg: 168,
  xl: 200
};
export var INFO_CARD_IMAGE_HEIGHT_MEDIUM = {
  xs: 140,
  md: 196,
  lg: 254,
  xl: 304
};
export var INFO_CARD_IMAGE_HEIGHT_LARGE = {
  xs: 184,
  sm: 230,
  lg: 292,
  xl: 288
};
export var INFO_CARD_IMAGE_BUTTON_OFFSET = {
  xs: 12,
  md: 16
};
export var INFO_CARD_IMAGE_CHIP_TOP_OFFSET = {
  xs: 14,
  md: 18,
  lg: 20,
  xl: 22
};
export var INFO_CARD_IMAGE_ICON_OFFSET = {
  xs: 4,
  lg: 8
};